import React, { useEffect, useMemo, useState } from "react";
import api from "../../services/api";
import { Link } from "react-router-dom";
import { formatParcours } from "../../services/aspirantUtils";

// const BACK_URL = "http://localhost:3000";
const BACK_URL = "https://backend.fmcadventistyouth.com";

export default function ValidationProofsDistrictWithComments() {
  const [districtName, setDistrictName] = useState("");

  // Liste globale (backend filtre déjà par rôle / district côté API)
  const [proofsAll, setProofsAll] = useState([]);
  const [loadingAll, setLoadingAll] = useState(true);
  const [errAll, setErrAll] = useState("");

  // Recherche globale par nom d'élève (appliquée aux 3 tableaux)
  const [searchName, setSearchName] = useState("");

  // Modale d'action (valider/refuser)
  const [showModal, setShowModal] = useState(false);
  const [currentProof, setCurrentProof] = useState(null);
  const [comment, setComment] = useState("");
  const [action, setAction] = useState("valide");
  const [submitting, setSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  // ---- Récupérer le nom du district connecté
  useEffect(() => {
    const fetchDistrictName = async () => {
      try {
        const me = await api.get("/auth/me/district");
        const { district_id } = me.data || {};
        if (district_id) {
          const res = await api.get(`/districtStats/district/${district_id}/name`);
          setDistrictName(res.data?.name || "");
        }
      } catch (err) {
        console.error("Erreur chargement district:", err);
      }
    };
    fetchDistrictName();
  }, []);

  // ---- Charger la liste globale
  useEffect(() => {
    const loadAll = async () => {
      try {
        setLoadingAll(true);
        const res = await api.get("/proofValidation/aspirant_district");
        setProofsAll(res.data || []);
        setErrAll("");
      } catch (e) {
        console.error("Erreur proofs/all:", e?.response?.status, e?.response?.data);
        setErrAll("Impossible de charger la liste globale des exigences.");
      } finally {
        setLoadingAll(false);
      }
    };
    loadAll();
  }, []);

  console.log("aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa", proofsAll);

  // ---- Utils
  const badge = (status) => {
    const s = (status || "").toLowerCase();
    if (s === "valide") return "success";
    if (s === "rejete" || s === "rejeté" || s === "refuse") return "danger";
    if (s === "en_attente") return "warning";
    return "secondary";
  };

  const buildViewerUrl = (filePath) => {
    if (!filePath) return "#";
    // Nettoyer le chemin : enlever /uploads/ si présent au début
    let cleanPath = String(filePath || "")
      .replace(/^\/+/, "")
      .replace(/^uploads\/?/i, "");
    // Si le chemin commence par proofs/, on le garde tel quel
    // Sinon on s'assure qu'il n'y a pas de double slash
    cleanPath = cleanPath.replace(/\/+/g, "/");
    const raw = cleanPath;
    const b64 = window
      .btoa(unescape(encodeURIComponent(raw)))
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=+$/, "");
    return `/dashboard-district/viewer?path=${encodeURIComponent(b64)}`;
  };

  const openModal = (proof, desiredAction) => {
    setCurrentProof(proof);
    setAction(desiredAction === "examiner" ? null : desiredAction);
    setComment(proof.comment || "");
    setErrorMessage("");
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setCurrentProof(null);
    setComment("");
    setAction("valide");
    setErrorMessage("");
  };

  const handleValidation = async (validationAction) => {
    if (!currentProof) return;

    // Si on refuse, le commentaire est obligatoire
    if (validationAction === "refuse" && (!comment || !comment.trim())) {
      setErrorMessage("Le commentaire est obligatoire pour refuser une exigence.");
      return;
    }
    
    // Réinitialiser le message d'erreur si la validation passe
    setErrorMessage("");

    try {
      setSubmitting(true);
      const payload = {
        status: validationAction, // "valide" | "refuse"
        comment: validationAction === "refuse" ? comment?.trim() || null : (comment?.trim() || null),
      };

      await api.patch(`/proofValidation/${currentProof.id}/validate`, payload);

      // MAJ locale
      setProofsAll((prev) =>
        prev.map((p) =>
          p.id === currentProof.id ? { ...p, status: payload.status, comment: payload.comment } : p
        )
      );

      closeModal();
      
      // Afficher un message de succès
      if (validationAction === "valide") {
        alert("Exigence validée avec succès !");
      } else {
        alert("Exigence refusée.");
      }
    } catch (e2) {
      console.error("Erreur validation:", e2);
      const errorMessage = e2?.response?.data?.error || e2?.message || "Échec de la mise à jour.";
      alert(errorMessage);
    } finally {
      setSubmitting(false);
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!currentProof || !action) return;

    // Si on refuse, le commentaire est obligatoire
    if (action === "refuse" && (!comment || !comment.trim())) {
      setErrorMessage("Le commentaire est obligatoire pour refuser une exigence.");
      return;
    }
    
    // Réinitialiser le message d'erreur si la validation passe
    setErrorMessage("");

    try {
      setSubmitting(true);
      const payload = {
        status: action, // "valide" | "refuse"
        comment: comment?.trim() || null,
      };

      await api.patch(`/proofValidation/${currentProof.id}/validate`, payload);

      // MAJ locale
      setProofsAll((prev) =>
        prev.map((p) =>
          p.id === currentProof.id ? { ...p, status: payload.status, comment: payload.comment } : p
        )
      );

      closeModal();
    } catch (e2) {
      console.error("Erreur validation:", e2);
      alert("Échec de la mise à jour. Réessaie.");
    } finally {
      setSubmitting(false);
    }
  };

  // ====== Filtres par statut + filtre global par nom d'élève ======
  const filterByName = (rows, q) => {
    const s = (q || "").trim().toLowerCase();
    if (!s) return rows || [];
    return (rows || []).filter((p) => (p.aspirant_name || "").toLowerCase().includes(s));
  };

  // En attente (tous parcours confondus)
  const rowsPending = useMemo(() => {
    const base = (proofsAll || []).filter(
      (p) => (p.status || "").toLowerCase() === "en_attente" || !p.status
    );
    return filterByName(base, searchName);
  }, [proofsAll, searchName]);

  // Validées (tous parcours confondus)
  const rowsValid = useMemo(() => {
    const base = (proofsAll || []).filter((p) => (p.status || "").toLowerCase() === "valide");
    return filterByName(base, searchName);
  }, [proofsAll, searchName]);

  // Refusées (tous parcours confondus)
  const rowsRefused = useMemo(() => {
    const base = (proofsAll || []).filter((p) => {
      const s = (p.status || "").toLowerCase();
      return s === "refuse" || s === "rejete" || s === "rejeté";
    });
    return filterByName(base, searchName);
  }, [proofsAll, searchName]);

  // ===== Colonne Requirement : largeur fixe + wrap lignes
  const REQ_WIDTH = 240; // px (réduit pour améliorer le responsive)

  // ---- Rendu d'un tableau (ajout de la colonne "Parcours")
  const renderTable = (title, rows, loadingFlag, errMsg, { showActions = true, statusColor = "primary", showExaminer = false } = {}) => {
    // Colonnes: Élève, Requirement, Parcours, Église, Soumise le, (Fichier/Commentaire si !showExaminer, sinon Action)
    const totalCols = showExaminer ? 5 : (showActions ? 7 : 6);
    // Réduire les largeurs minimales pour améliorer le responsive sur desktop
    const minWidthPx = showExaminer ? Math.max(750, REQ_WIDTH + 450) : Math.max(showActions ? 950 : 850, REQ_WIDTH + 650);

    // Définir les couleurs selon le statut
    const headerClass = statusColor === "warning" ? "bg-warning text-dark" 
                      : statusColor === "success" ? "bg-success text-white"
                      : statusColor === "danger" ? "bg-danger text-white"
                      : "bg-primary text-white";

    return (
      <>
        <div className={`card-header ${headerClass} d-flex align-items-center justify-content-between`}>
          <span className="fw-bold">{title}</span>
          <span className="badge bg-white text-dark ms-2">{rows.length}</span>
        </div>

        {loadingFlag ? (
          <div className="p-4">Chargement…</div>
        ) : errMsg ? (
          <div className="alert alert-danger m-3">{errMsg}</div>
        ) : (
          <>
          {/* Version desktop : tableau */}
          <div
            className="table-responsive d-none d-lg-block"
            style={{
              overflowX: "auto",
              overflowY: "auto",
              maxHeight: "70vh",
              WebkitOverflowScrolling: "touch",
              width: "100%",
            }}
          >
            <table
              className="table table-hover table-sm align-middle mb-0"
              style={{ 
                minWidth: minWidthPx,
                width: "100%",
                tableLayout: "auto"
              }}
            >
              <colgroup>
                <col style={{ minWidth: "120px", width: "auto" }} />  {/* Élève */}
                <col style={{ width: REQ_WIDTH, minWidth: REQ_WIDTH }} />   {/* Requirement (fixe) */}
                <col style={{ minWidth: "100px", width: "auto" }} />  {/* Parcours */}
                <col style={{ minWidth: "120px", width: "auto" }} />  {/* Église */}
                {!showExaminer && <col style={{ minWidth: "100px", width: "auto" }} />}  {/* Fichier (si pas examiner) */}
                <col style={{ minWidth: "100px", width: "auto" }} />  {/* Soumise le (date seule) */}
                {!showExaminer && <col style={{ minWidth: "150px", width: "auto" }} />}  {/* Commentaire (si pas examiner) */}
                {showExaminer && <col style={{ minWidth: "100px", width: "auto" }} />}  {/* Action (Examiner) */}
                {showActions && !showExaminer && <col style={{ minWidth: "150px", width: "auto" }} />}  {/* Actions (si pas examiner) */}
              </colgroup>

              <thead className="table-light">
                <tr>
                  <th className="text-nowrap">Élève</th>
                  <th className="text-nowrap" style={{ width: REQ_WIDTH }}>Requirement</th>
                  <th className="text-nowrap">Parcours</th>
                  <th className="text-nowrap">Église</th>
                  {!showExaminer && <th className="text-nowrap">Fichier</th>}
                  <th className="text-nowrap">Soumise le</th>
                  {!showExaminer && <th className="text-nowrap">Commentaire</th>}
                  {showExaminer && <th className="text-end text-nowrap">Action</th>}
                  {showActions && !showExaminer && <th className="text-end text-nowrap">Actions</th>}
                </tr>
              </thead>

              <tbody>
                {rows.length === 0 ? (
                  <tr>
                    <td colSpan={totalCols} className="text-center text-muted py-4">
                      Aucune exigence trouvée.
                    </td>
                  </tr>
                ) : (
                  rows.map((p) => {
                    const isValidated = (p.status || "").toLowerCase() === "valide";
                    // Ajouter une couleur de fond subtile selon le statut
                    const rowBgClass = statusColor === "warning" ? "table-warning" 
                                     : statusColor === "success" ? "table-success" 
                                     : statusColor === "danger" ? "table-danger"
                                     : "";
                    return (
                      <tr key={p.id} className={rowBgClass}>
                        {/* Élève */}
                        <td className="text-break" style={{ minWidth: "120px" }}>{p.aspirant_name || "—"}</td>

                        {/* Requirement — largeur fixe + wrap */}
                        <td
                          style={{
                            width: REQ_WIDTH,
                            maxWidth: REQ_WIDTH,
                            whiteSpace: "normal",
                          }}
                        >
                          <div
                            style={{
                              overflowWrap: "anywhere",
                              wordBreak: "break-word",
                              whiteSpace: "pre-wrap",
                            }}
                            title={p.description || ""}
                          >
                            {p.description || "—"}
                          </div>
                        </td>

                        {/* Parcours — NOUVEAU */}
                        <td className="text-break" style={{ minWidth: "100px" }}>
                          {formatParcours(p.requirement_parcours) || "—"}
                        </td>

                        {/* Église */}
                        <td className="text-break" style={{ minWidth: "120px" }}>{p.eglise_name || "—"}</td>

                        {/* Fichier (seulement si pas en mode Examiner) */}
                        {!showExaminer && (
                          <td className="text-nowrap">
                            {p.justification_file ? (
                              <Link
                                to={buildViewerUrl(p.justification_file)}
                                target="_blank"
                                className="btn btn-primary btn-sm text-nowrap"
                                title="Ouvrir dans la visionneuse"
                              >
                                Voir le doc
                              </Link>
                            ) : (
                              <span className="text-muted">—</span>
                            )}
                          </td>
                        )}

                        {/* Date — seulement la date (pas l'heure) */}
                        <td className="text-nowrap">
                          {p.created_at
                            ? new Date(p.created_at).toLocaleDateString()
                            : "—"}
                        </td>

                        {/* Commentaire (affichage résumé, seulement si pas en mode Examiner) */}
                        {!showExaminer && (
                          <td style={{ minWidth: "150px", maxWidth: "300px" }}>
                            <div className="text-truncate" style={{ maxWidth: "100%" }}>
                              {p.comment || <span className="text-muted">—</span>}
                            </div>
                          </td>
                        )}

                        {/* Action Examiner (seulement si showExaminer) */}
                        {showExaminer && (
                          <td className="text-end">
                            {!isValidated && (
                              <button
                                className="btn btn-primary btn-sm text-nowrap"
                                onClick={() => openModal(p, "examiner")}
                              >
                                <i className="bi bi-eye me-1"></i>
                                Examiner
                              </button>
                            )}
                          </td>
                        )}

                        {/* Actions (seulement si pas en mode Examiner) */}
                        {showActions && !showExaminer && (
                          <td className="text-end">
                            {!isValidated && (
                              <div className="btn-group btn-group-sm flex-nowrap">
                                <button
                                  className="btn btn-outline-success text-nowrap"
                                  onClick={() => openModal(p, "valide")}
                                >
                                  Valider
                                </button>
                                <button
                                  className="btn btn-outline-danger text-nowrap"
                                  onClick={() => openModal(p, "refuse")}
                                >
                                  Refuser
                                </button>
                              </div>
                            )}
                          </td>
                        )}
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>

          {/* Version tablette et mobile : cartes */}
          <div className="d-lg-none p-3">
            {rows.length === 0 ? (
              <div className="text-center text-muted py-4">Aucune exigence trouvée.</div>
            ) : (
              rows.map((p) => {
                const isValidated = (p.status || "").toLowerCase() === "valide";
                const bgClass = statusColor === "warning" ? "border-warning" 
                             : statusColor === "success" ? "border-success" 
                             : statusColor === "danger" ? "border-danger"
                             : "";
                return (
                  <div key={p.id} className={`card mb-3 shadow-sm ${bgClass}`} style={{ borderWidth: 2 }}>
                    <div className="card-body p-3">
                      <div className="mb-2">
                        <strong className="d-block mb-1 text-primary">Élève:</strong>
                        <span className="text-break">{p.aspirant_name || "—"}</span>
                      </div>
                      
                      <div className="mb-2">
                        <strong className="d-block mb-1 text-primary">Exigence:</strong>
                        <div className="text-break" style={{ wordBreak: "break-word", whiteSpace: "pre-wrap" }}>
                          {p.description || "—"}
                        </div>
                      </div>
                      
                      <div className="mb-2">
                        <strong className="d-block mb-1 text-primary">Parcours:</strong>
                        <span>{formatParcours(p.requirement_parcours) || "—"}</span>
                      </div>
                      
                      <div className="mb-2">
                        <strong className="d-block mb-1 text-primary">Église:</strong>
                        <span className="text-break">{p.eglise_name || "—"}</span>
                      </div>
                      
                      {!showExaminer && (
                        <div className="mb-2">
                          <strong className="d-block mb-1 text-primary">Fichier:</strong>
                          {p.justification_file ? (
                            <Link
                              to={buildViewerUrl(p.justification_file)}
                              target="_blank"
                              className="btn btn-primary btn-sm w-100"
                            >
                              <i className="bi bi-file-earmark-pdf me-1"></i>
                              Voir le doc
                            </Link>
                          ) : (
                            <span className="text-muted">—</span>
                          )}
                        </div>
                      )}
                      
                      <div className="mb-2">
                        <strong className="d-block mb-1 text-primary">Soumise le:</strong>
                        <span>
                          {p.created_at
                            ? new Date(p.created_at).toLocaleDateString("fr-FR")
                            : "—"}
                        </span>
                      </div>
                      
                      {!showExaminer && (
                        <div className="mb-2">
                          <strong className="d-block mb-1 text-primary">Commentaire:</strong>
                          <div className="text-break" style={{ wordBreak: "break-word" }}>
                            {p.comment || <span className="text-muted">—</span>}
                          </div>
                        </div>
                      )}
                      
                      {showExaminer && !isValidated && (
                        <div className="mt-3">
                          <button
                            className="btn btn-primary btn-sm w-100"
                            onClick={() => openModal(p, "examiner")}
                          >
                            <i className="bi bi-eye me-1"></i>
                            Examiner
                          </button>
                        </div>
                      )}
                      
                      {showActions && !showExaminer && !isValidated && (
                        <div className="mt-3 d-flex gap-2">
                          <button
                            className="btn btn-outline-success btn-sm flex-fill"
                            onClick={() => openModal(p, "valide")}
                          >
                            <i className="bi bi-check-circle me-1"></i>
                            Valider
                          </button>
                          <button
                            className="btn btn-outline-danger btn-sm flex-fill"
                            onClick={() => openModal(p, "refuse")}
                          >
                            <i className="bi bi-x-circle me-1"></i>
                            Refuser
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                );
              })
            )}
          </div>
          </>
        )}
      </>
    );
  };

  return (
    <div className="container-fluid px-2 px-md-3 px-lg-4">
      {/* Bandeau avec nom du district */}
      <div className="card shadow-sm mt-3">
        <div className="card-header bg-dark text-white">
          <strong className="d-none d-md-inline">
            {districtName ? `Exigences – District ${districtName}` : "Exigences – District"}
          </strong>
          <strong className="d-md-none">
            {districtName ? `District ${districtName}` : "Exigences"}
          </strong>
        </div>
      </div>

      {/* Barre de recherche globale (par nom d'élève) */}
      <div className="card shadow-sm mt-3">
        <div className="card-body">
          <div className="row g-2 align-items-center">
            <div className="col-12 col-md-4">
              <label htmlFor="searchName" className="form-label mb-0">
                Rechercher un élève
              </label>
            </div>
            <div className="col-12 col-md-8">
              <div className="input-group">
                <span className="input-group-text">
                  <i className="bi bi-search" />
                </span>
                <input
                  id="searchName"
                  type="text"
                  className="form-control"
                  placeholder="Nom de l'élève…"
                  value={searchName}
                  onChange={(e) => setSearchName(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* En attente (tous parcours confondus) */}
      <div className="card shadow-sm mt-4 border-warning border-2">
        {renderTable(
          "Exigences en attente",
          rowsPending,
          loadingAll,
          errAll,
          { showActions: false, statusColor: "warning", showExaminer: true }
        )}
      </div>

      {/* Validées (tous parcours confondus) */}
      <div className="card shadow-sm mt-4 border-success border-2">
        {renderTable(
          "Exigences validées",
          rowsValid,
          loadingAll,
          errAll,
          { showActions: false, statusColor: "success" }
        )}
      </div>

      {/* Refusées (tous parcours confondus) */}
      <div className="card shadow-sm mt-4 border-danger border-2">
        {renderTable(
          "Exigences refusées",
          rowsRefused,
          loadingAll,
          errAll,
          { showActions: false, statusColor: "danger" }
        )}
      </div>

      {/* Modale validation/refus */}
      {showModal && currentProof && (
        <div
          className="modal fade show"
          style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
          tabIndex="-1"
          role="dialog"
          aria-modal="true"
          onClick={closeModal}
        >
          <div
            className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content">
              <div className="modal-header bg-primary text-white">
                <h5 className="modal-title">
                  <i className="bi bi-file-check me-2"></i>
                  {action ? (action === "valide" ? "Valider" : "Refuser") : "Examiner"} l'exigence - {currentProof?.aspirant_name || "—"}
                </h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={closeModal}
                />
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <h6 className="text-primary">Informations de l'exigence</h6>
                  <p className="mb-1"><strong>Élève :</strong> {currentProof?.aspirant_name || "—"}</p>
                  <p className="mb-1"><strong>Requirement :</strong> {currentProof?.description || "—"}</p>
                  <p className="mb-1"><strong>Parcours :</strong> {formatParcours(currentProof?.requirement_parcours) || "—"}</p>
                  <p className="mb-1"><strong>Église :</strong> {currentProof?.eglise_name || "—"}</p>
                  {currentProof?.created_at && (
                    <p className="mb-0"><strong>Soumise le :</strong> {new Date(currentProof.created_at).toLocaleDateString("fr-FR")}</p>
                  )}
                </div>

                {currentProof?.justification_file && (
                  <div className="mb-3">
                    <h6 className="text-primary">Document</h6>
                    <Link
                      to={buildViewerUrl(currentProof.justification_file)}
                      className="btn btn-primary"
                      title="Ouvrir dans la visionneuse"
                      target="_blank"
                    >
                      <i className="bi bi-eye me-1"></i>
                      Voir le document
                    </Link>
                  </div>
                )}

                <div className="mb-3">
                  <label className="form-label">
                    <strong>Commentaire</strong>{" "}
                    <small className="text-muted">
                      {action === "refuse" ? "(obligatoire)" : "(optionnel)"}
                    </small>
                  </label>
                  {errorMessage && (
                    <div className="alert alert-danger mb-2" role="alert">
                      <i className="bi bi-exclamation-triangle me-2"></i>
                      {errorMessage}
                    </div>
                  )}
                  <textarea
                    className={`form-control ${errorMessage ? "is-invalid" : ""}`}
                    rows="4"
                    value={comment}
                    onChange={(e) => {
                      setComment(e.target.value);
                      // Effacer le message d'erreur quand l'utilisateur commence à taper
                      if (errorMessage) setErrorMessage("");
                    }}
                    placeholder={
                      action === "refuse"
                        ? "Expliquez pourquoi l'exigence est refusée…"
                        : "Ajoutez un commentaire si nécessaire..."
                    }
                  />
                </div>
              </div>
              <div className="modal-footer d-flex flex-column flex-md-row gap-2">
                <button
                  type="button"
                  className="btn btn-secondary w-100 w-md-auto"
                  onClick={closeModal}
                  disabled={submitting}
                >
                  Annuler
                </button>
                {!action ? (
                  <>
                    <button
                      type="button"
                      className="btn btn-danger w-100 w-md-auto"
                      onClick={() => handleValidation("refuse")}
                      disabled={submitting}
                    >
                      {submitting ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" />
                          Traitement...
                        </>
                      ) : (
                        <>
                          <i className="bi bi-x-circle me-1"></i>
                          Refuser
                        </>
                      )}
                    </button>
                    <button
                      type="button"
                      className="btn btn-success w-100 w-md-auto"
                      onClick={() => handleValidation("valide")}
                      disabled={submitting}
                    >
                      {submitting ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" />
                          Traitement...
                        </>
                      ) : (
                        <>
                          <i className="bi bi-check-circle me-1"></i>
                          Valider
                        </>
                      )}
                    </button>
                  </>
                ) : (
                  <button
                    type="button"
                    className={`btn w-100 w-md-auto ${action === "valide" ? "btn-success" : "btn-danger"}`}
                    onClick={() => handleValidation(action)}
                    disabled={submitting}
                  >
                    {submitting ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" />
                        Traitement...
                      </>
                    ) : (
                      <>
                        <i className={`bi ${action === "valide" ? "bi-check-circle" : "bi-x-circle"} me-1`}></i>
                        {action === "valide" ? "Valider" : "Refuser"}
                      </>
                    )}
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
